import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import PaginationComponent from "../Datatable/Pagination/Index";
import UseFullPageLoader from "../FullPageLoader/UseFullPageLoader";
import UseGeoLoaction from "./UseGeoLocation";

const FavoriteList = () => {
    document.title = "DirtMap - Favorites";

    const today = Date.now();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [favoriteList, setFavoriteList] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [calDistance, setCalDistance] = useState(0);
    const ITEMS_PER_PAGE = 10;
    const [loader, showLoader, hideLoader] = UseFullPageLoader();
    const location = UseGeoLoaction();

    const getFavoriteListData = async () => {
        const userId = localStorage.getItem('user_id'); 
        await axios.post(`/api/favorite/list`, { user_id: userId }).then(res => {
            if (res.data.result) {
                setFavoriteList(res.data.result);
                hideLoader();
            }
            setLoading(false);
            hideLoader();
        });
    }

    useEffect(() => {
        showLoader();
        getFavoriteListData();
        hideLoader();
    }, []);


    const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

    const deg2rad = (deg) => {
        return deg * (Math.PI / 180)
    }


    const secondsToDhms = (seconds) => {
        seconds = Number(seconds);
        var d = Math.floor(seconds / (3600 * 24));
        var h = Math.floor(seconds % (3600 * 24) / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 60);

        var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
        var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
        var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
        //var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
        return dDisplay + hDisplay + mDisplay;
    }


    const updateStatus = (e, id, status) => {
        showLoader();
        e.preventDefault();
        const thisclicked = e.currentTarget;
        let statusMsg = status === '1' ? 'Renew' : 'Active';
        thisclicked.innerText = statusMsg;
        axios.post(`/api/update/status/post/site/${id}/${status}`).then(res => {
            if (res.data.status_code === 200) {
                swal('success', res.data.message, 'success');
                getFavoriteListData();
                hideLoader();
                //thisclicked.closest('tr').remove();
            } else if (res.data.status_code === 404) {
                swal('error', 'No Post Site Id Found', 'error');
                //thisclicked.innerHtml = 'Delete';
            }
        });
    }

    const favoriteListData = useMemo(() => {
        let computedFavoriteList = favoriteList;
        setTotalItems(computedFavoriteList.length);
        return computedFavoriteList.slice(

            (currentPage - 1) * ITEMS_PER_PAGE,
            (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE

        );
    }, [favoriteList, currentPage]);

    var listfavorites_HTML = "";
    if (loading) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;
    } else {
        listfavorites_HTML =
            favoriteListData.map((item, index) => {

                const created_at = new Date(item.created_at);
                const coordinates = location.loaded ? location.coordinates : '';
                console.log(coordinates);
                const findDistance = coordinates ? getDistanceFromLatLonInKm(coordinates.lat, coordinates.lng, item.latitude, item.longitude) : 0;
                console.log(findDistance);
                const hour = findDistance ? findDistance / 40 : 0;
                const time = hour * 3600;
                const dayTimeMinutesSecond = secondsToDhms(time);

                return (<div className="favoritesList shadowBox" key={item.id}>
                    <div className="row">
                        <div className="col-md-5">
                            <div className="favImgThumb">
                                {item.images[0] ?
                                    <img src={item.images[0]} width="434" height="224" className="imgResponsive" />
                                    :
                                    <img src={"/frontend/images/placeholder.jpg"} width="434" height="224" className="imgResponsive" />
                                }

                                {/* <div className="shareIcon">
                                    <Link
                                        to="#">
                                        <i className="fa fa-share-alt" aria-hidden="true" />
                                    </Link>
                                    <Link
                                        to="#">
                                        <i className="fa fa-heart-o heart-icon-post-listing" aria-hidden="true" ></i>
                                    </Link>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-md-7 actionButtons">
                            <h2 className="bottomBorder">{item.project_name}</h2>
                            <p className="truckInfo bottomBorder"><span><i className="fa fa-truck" aria-hidden="true" />{item.special_instruction}</span>
                                <span className="space">&nbsp;</span>
                                <span><i className="fa fa-map-marker" aria-hidden="true" />

                                    {/* {getDistanceFromLatLonInKm(location.coordinates.lat, location.coordinates.lng, )}  */}
                                    {/* {console.log(location.coordinates.lat)}
                                {console.log(location.coordinates.lng)} */}
                                    {/* {location.loaded ? JSON.stringify(location) : "Location does not available yet."} */}
                                    {dayTimeMinutesSecond
                                        ? dayTimeMinutesSecond : 'Location not Available / Allow yet.'}
                                </span>
                            </p>
                            <p>{item.project_name}</p>
                            <Link className="button customButton01" to={`/detail/${item.id}`}> View Full Detail</Link>


                            {/* <Link to="#" className={`button customButton01 ${!localStorage.getItem('auth_token') ? 'hide' : ''} `} onClick={(e) => updateStatus(e, item.id, item.status)}>
                                {item.status === '1' ? 'Active' : 'Renew'}
                            </Link> */}


                        </div>
                    </div>
                </div>)
            });
    }
    return (

        <>
            <section className="breadcrumb">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 bread-crumb">
                            <Link to="/">Home</Link><span>&gt;</span>Favorites
                        </div>
                    </div>
                </div>
                <hr />
            </section>
            <section className="contentContainer">
                <div className="container">

                    {listfavorites_HTML}

                    <div className="text-right">

                        <PaginationComponent
                            total={totalItems}
                            itemsPerPage={ITEMS_PER_PAGE}
                            currentPage={currentPage}
                            onPageChange={page => setCurrentPage(page)}
                        />


                    </div>
                </div>
            </section>
            {loader}
        </>

    )
}

export default FavoriteList;